export const REDLIKE_LIGHT = false;
export const GAMMA_FRONTDESK = false;
export const GAMMA_MACHINE = false;
export const WEBER = false;
export const COLORIS = false;
export const REDLIKE_LIGHT_AT_STARTUP = false;
export const DEFAULT_BASIC_SETUP = true;

export const CONNECT_HELPER = false;

export const DEFAULT_SERVER = "localhost";
export const DEFAULT_RCC = "localhost";
export const DEFAULT_HELPER = "localhost";
export const DEFAULT_LOCK_COMPUTER = false;
export const DEFAULT_SCREENSAVER = true;
export const DEFAULT_SCREENSAVER_TIME = 10;
export const DEFAULT_STYLE = null;
export const DEFAULT_LANGUAGE = "en-GB";
export const DEFAULT_DATABASE = null;
export const DEFAULT_HELP = "";
export const DEFAULT_PING_INTERVAL = 3600;
export const DEFAULT_PLUGINS = {};
